import styled from "styled-components";
import {
  normalStrongStyles,
  primary01,
  primary02,
  semanticGreen,
  semanticRed01,
  shade0,
  shade200,
  shade300,
  shade400,
  shade600,
  shade700,
  shade800,
  shade850,
  shade900,
  shade950,
  smallStyles,
} from "@songtradr-one/components-frontend";
import type { UploadBucketKey } from "@songtradr-one/shared-common";

// TEXT

// STYLES
export const UppyWrapper = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  .uppy-Dashboard,
  .uppy-Container,
  .uppy-Root {
    flex: 1;
    display: flex;
    min-height: 0;
  }
  .uppy-Root {
    font-family: inherit;
    font-weight: 500;
    font-size: 1rem;
    letter-spacing: 0.06em;
    -webkit-font-smoothing: antialiased;
    * {
      font-weight: 500;
      font-size: 1rem;
      letter-spacing: 0.06em;
      -webkit-font-smoothing: antialiased;
    }
  }

  .uppy-size--md .uppy-DashboardTab-name {
    ${smallStyles};
  }
  .uppy-Dashboard-inner {
    background-color: ${shade900};
    border-radius: 0;
    border: solid 1px ${shade800};
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }
  .uppy-Dashboard-innerWrap {
    min-height: 0;
  }

  .uppy-Dashboard-AddFiles {
    border: none;
    border-radius: 0;
  }

  .uppy-dashboardcontent-back {
    color: ${shade400};
  }

  /* Browse / upload buttons */
  .uppy-DashboardContent-back,
  .uppy-DashboardContent-save {
    color: ${shade300};
    font-weight: 500;
    font-size: 1rem;
    &:hover,
    &:focus {
      color: ${shade0};
    }
  }

  /* Browse button (higher specificity to override Uppy defaults) */
  .uppy-Dashboard-AddFiles .uppy-Dashboard-browse {
    color: ${primary01};
    font-weight: 500;
    font-size: 1rem;
    border-color: ${primary01};
  }

  /* Primary action buttons (Upload, etc.) */
  .uppy-StatusBar-actionBtn--upload,
  .uppy-c-btn-primary {
    background-color: ${shade950};
    color: ${shade0};
    border: none;
    border-radius: 0;

    &:hover,
    &:focus {
      background-color: ${shade850};
    }
  }

  .uppy-StatusBar-actionBtn {
    border-radius: 0;
    &:hover,
    &:focus {
      background-color: ${primary02};
    }
  }

  .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {
    background-color: ${primary01};
    height: 2.5rem;
    padding: 0 1rem;
    ${normalStrongStyles}
    line-height: 1rem;
    color: ${shade0};
    cursor: pointer;
    &:hover,
    &:focus {
      background-color: ${primary02};
    }
  }

  /* Progress bar */
  .uppy-StatusBar-progress {
    background-color: ${primary01};
  }
  .uppy-StatusBar.is-complete .uppy-StatusBar-progress {
    background-color: ${semanticGreen};
  }
  .uppy-StatusBar.is-error .uppy-StatusBar-progress {
    background-color: ${semanticRed01};
  }

  /* Status bar */
  .uppy-StatusBar {
    background-color: ${shade950};
    border-top: 1px solid ${shade800};
    color: ${shade200};
  }
  .uppy-StatusBar-actionBtn--done {
    color: ${shade300};
    font-weight: 500;
    &:hover,
    &:focus {
      color: ${shade0};
      background: none;
    }
  }

  /* Secondary / cancel buttons */
  .uppy-StatusBar-actionBtn--retry,
  .uppy-StatusBar-actionBtn--cancel {
    color: ${shade400};

    &:hover,
    &:focus {
      color: ${shade200};
    }
  }

  /* Force compact list view instead of grid tiles */
  .uppy-Dashboard-filesContainer {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
  }
  .uppy-Dashboard-files {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    height: 0;
    padding-top: 0;
  }
  .uppy-size--md .uppy-Dashboard-files {
    padding-top: 0;
  }
  .uppy-size--md .uppy-Dashboard-Item,
  .uppy-size--lg .uppy-Dashboard-Item,
  .uppy-size--xl .uppy-Dashboard-Item {
    display: flex;
    float: none;
    width: 100%;
    height: auto;
    margin: 0;
    padding: 6px 16px;
    border-bottom: 1px solid ${shade800};
    align-items: center;
    &:hover {
      background-color: ${shade850};
    }
  }
  .uppy-Dashboard-Item {
    border-bottom: 1px solid ${shade800};
    padding: 6px 16px;
    &:hover {
      background-color: ${shade850};
    }
  }
  .uppy-size--md .uppy-Dashboard-Item-previewInnerWrap,
  .uppy-size--lg .uppy-Dashboard-Item-previewInnerWrap,
  .uppy-size--xl .uppy-Dashboard-Item-previewInnerWrap {
    width: 28px;
    height: 28px;
  }
  .uppy-size--md .uppy-Dashboard-Item-preview,
  .uppy-size--lg .uppy-Dashboard-Item-preview,
  .uppy-size--xl .uppy-Dashboard-Item-preview {
    width: 28px;
    height: 28px;
    min-width: 28px;
    margin-right: 10px;
  }
  .uppy-Dashboard-Item-fileInfo {
    flex: 1;
    min-width: 0;
  }
  /* Scale down progress indicators for list view */
  .uppy-size--md .uppy-Dashboard-Item-progress,
  .uppy-size--lg .uppy-Dashboard-Item-progress,
  .uppy-size--xl .uppy-Dashboard-Item-progress {
    width: 28px;
  }
  .uppy-size--md .uppy-Dashboard-Item-progressIndicator,
  .uppy-size--lg .uppy-Dashboard-Item-progressIndicator,
  .uppy-size--xl .uppy-Dashboard-Item-progressIndicator {
    width: 24px;
    height: 24px;
  }
  .uppy-size--md .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress,
  .uppy-size--lg .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress,
  .uppy-size--xl
    .uppy-Dashboard-Item.is-complete
    .uppy-Dashboard-Item-progress {
    top: -6px;
    inset-inline-end: -6px;
  }
  .uppy-size--md
    .uppy-Dashboard-Item.is-complete
    .uppy-Dashboard-Item-progressIndicator,
  .uppy-size--lg
    .uppy-Dashboard-Item.is-complete
    .uppy-Dashboard-Item-progressIndicator,
  .uppy-size--xl
    .uppy-Dashboard-Item.is-complete
    .uppy-Dashboard-Item-progressIndicator {
    width: 16px;
    height: 16px;
  }
  .uppy-Dashboard-Item-name {
    margin-bottom: 0;
    color: ${shade200};
  }
  .uppy-Dashboard-Item-statusSize {
    margin-bottom: 0;
    font-size: 0.875rem;
    color: ${shade700};
  }
  /* Reset remove button from absolute (tile mode) to inline flow */
  .uppy-size--md .uppy-Dashboard-Item-action--remove,
  .uppy-size--lg .uppy-Dashboard-Item-action--remove,
  .uppy-size--xl .uppy-Dashboard-Item-action--remove {
    position: static;
    width: 22px;
    height: 22px;
    padding: 3px;
    margin-left: 8px;
    flex-shrink: 0;
    color: ${shade600};
    opacity: 1;
    &:hover {
      color: ${semanticRed01};
    }
  }
  .uppy-size--md .uppy-Dashboard-Item-actionWrapper,
  .uppy-size--lg .uppy-Dashboard-Item-actionWrapper,
  .uppy-size--xl .uppy-Dashboard-Item-actionWrapper {
    display: flex;
    align-items: center;
  }

  .uppy-StatusBar-statusPrimary {
    font-weight: 600;
  }

  .uppy-StatusBar-statusPrimary,
  .uppy-StatusBar-additionalInfo {
    font-size: 0.75rem;
  }
  /* File action buttons (remove, edit) */
  .uppy-Dashboard-Item-action--remove {
    color: ${shade400};

    &:hover {
      color: ${semanticRed01};
    }
  }

  /* Provider tabs (Google Drive, Dropbox) */
  .uppy-DashboardTab-btn {
    color: ${shade400};

    &:hover {
      color: ${shade0};
      background-color: ${shade850};
    }
  }
  .uppy-DashboardTab-btn[aria-selected="true"] {
    color: ${shade0};
    background-color: ${shade850};
  }

  /* Drop area note */
  .uppy-Dashboard-note {
    color: ${shade700};
  }

  /* Add more files button */
  .uppy-DashboardContent-addMore {
    color: ${shade300};
    border-color: ${shade800};
    font-size: 1rem;
    &:hover {
      color: ${shade0};
    }
  }

  /* Provider browser panels */
  .uppy-ProviderBrowser,
  .uppy-ProviderBrowserItem {
    background-color: ${shade900};
    color: ${shade200};
    border-color: ${shade800};
  }
`;

// DATA

// TYPES
export type FileUploaderProps = {
  id?: string;
  bucketKey: UploadBucketKey;
  /** Extra metadata sent to Companion's s3 params endpoint (e.g. { jobId }) */
  metadata?: Record<string, string>;
  onUploadSuccess?: (
    fileName: string,
    fileType?: string,
    fileSize?: number,
    s3Key?: string,
  ) => void;
  onUploadError?: (error: Error) => void;
  onAllUploadsComplete?: () => void;
  maxFileSize?: number;
  maxNumberOfFiles?: number;
  allowedFileTypes?: string[];
  description?: string;
  /** Show Google Drive / Dropbox provider tabs (default true) */
  cloudProviders?: boolean;
};

// CONSTANTS
export const DEFAULT_MAX_FILE_SIZE = 5 * 1024 * 1024 * 1024; // 5GB
// Presigned POSTs are capped at 100MB server-side; larger files go multipart
export const MULTIPART_THRESHOLD = 100 * 1024 * 1024; // 100MB
/** Explicit id of the S3 plugin, so its options can be updated later */
export const S3_PLUGIN_ID = "AwsS3Multipart";

// FUNCTIONS
/** Meta fields the S3 plugin forwards: the bucket key plus any metadata keys */
export const getAllowedMetaFields = (metadata?: Record<string, string>) => [
  "bucketKey",
  ...Object.keys(metadata ?? {}),
];

// ASSETS
